// extracted by mini-css-extract-plugin
export default {"pagination-sticky":"appPagination_pagination-sticky__b2cMY"};